import styled from 'styled-components'
import React, {useState} from "react"
import Text from '../../global/typo/Text'
import { navigate } from 'gatsby'
import { usePageContext } from '../../global/hooks/usePageContext'


const LangSwitcher = (props) => {
  const [showOptions, setShowOptions] = useState(false)
  const {paths, lang, languages} = usePageContext()
  const FullLangNames = {en: 'En',es: 'Es', de: 'De', fr: 'Fr'}
  
  function switchLanguages(language){
    navigate(paths[language])
  }

  return(
    <>
      {languages.length > 1 &&
      <Wrapper onClick={()=> setShowOptions(!showOptions)} $show={showOptions}>
        <SelectedLanguage  $show={showOptions} $border={props.$border} $small={props.$small} $smallBorder={props.$smallBorder}>
          <SwitcherText>{FullLangNames[lang]}</SwitcherText>
           <Chevron $show={showOptions} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <polyline points="6 9 12 15 18 9" />
            </Chevron>
        </SelectedLanguage>
        {languages.includes("es") && <LanguageOption onClick={()=> switchLanguages("es")} $show={showOptions}><SwitcherText>Español</SwitcherText></LanguageOption>}
        {languages.includes("en") && <LanguageOption onClick={()=> switchLanguages("en")} $show={showOptions}><SwitcherText>English</SwitcherText></LanguageOption>}
        {languages.includes("de") && <LanguageOption onClick={()=> switchLanguages("de")} $show={showOptions}><SwitcherText>Deutsch</SwitcherText></LanguageOption>}
        {languages.includes("fr") && <LanguageOption onClick={()=> switchLanguages("fr")} $show={showOptions}><SwitcherText>Français</SwitcherText></LanguageOption>}
      </Wrapper>
      }
    </>

  )
}

export default LangSwitcher


const LanguageOption = styled.div`
  margin: 5px 0px;
  color:white;
  text-transform: uppercase;
  background-color:#f19d9a;
  display:flex;
  border-radius:20px;
  align-items: center;
  width:80px;
  height: 35px;
  justify-content: center;
  text-decoration:none;
  ${props => props.$show ? 'height: 35px;': 'height: 0px;opacity:0;visibility:hidden;'}
  height: 35px;
  transition: all 0.4s ease-in-out;
  @media (max-width: 479px){
    height: 35px;
  }
`

const SelectedLanguage= styled.div`
  ${props => props.$border ? 'border:1px solid black': 'border:0px'};
  ${props => props.$show ? 'background-color:#f19d9a; border:0px;': 'background-color:none;'}
  ${props => props.$show ? 'color:white': 'color:black;'};
  text-transform: uppercase;
  border-radius:20px;
  width:80px;
  height: 35px;
  display:flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 479px){
    ${props => props.$small ? 'width: 60px;height: 25px;': ''};
    ${props => props.$smallBorder && !props.show  ? 'border:1px solid black;': 'border:0px;'};
  }
`

const Chevron = styled.svg`
  ${props => props.$show ? 'stroke:white': 'stroke:black;'};
  ${props => props.$show ? 'transform:scaleY(-1);': 'transform:scaleY(1);'}
  @media (max-width: 479px){
    width:20px;
  }
  width:25px;
  stroke-width:2;
  fill:none; 
  stroke-linecap:round; 
  stroke-linejoin:round;
`


const SwitcherText = styled(Text)`
  @media (max-width: 479px){
    font-size:0.8rem;
  }
`

const Wrapper = styled.div`
  ${props => props.$show ? 'height:auto;overflow:visible;': 'height:40px;'};
`